export default __webpack_public_path__ + "locales/pt-BR/DeleteDialog.json?hash=f174c73f2dd6839c96601bb860ec55ec";